module.exports = __webpack_public_path__ + "media/images/flags/64/Paraguay-c91a3090f383357f67ebee57315d1d0e.png";